import { PseudoPostType } from 'constants/post';
import {
  TYPE_FACEBOOK,
  TYPE_GOOGLE_MY_BUSINESS,
  TYPE_INSTAGRAM,
  TYPE_LINKEDIN,
  TYPE_THREADS,
  TYPE_TWITTER,
} from '@kontentino/kontentino-constants/Pages';
import { processReelAttachments } from './reel';
import { processStoryAttachments } from './story';
import { AttachmentsHandler } from './types';
import { getAttachmentCards } from './helpers';
import { processPhotoAttachments } from './photo';
import { processAllAttachments } from './all';
import { processVideoAttachments } from './video';

export const processPostAttachments = ({
  pseudoPost,
  form,
  attachmentsByPseudoType,
}: AttachmentsHandler) => {
  const attachmentCards = getAttachmentCards({
    attachmentsByPseudoType,
    pseudoType: pseudoPost.key,
    form,
  });

  if (attachmentCards.length) {
    return attachmentCards;
  }

  const handlerByPageType: Record<number, Record<string, Function>> = {
    [TYPE_FACEBOOK]: {
      [PseudoPostType.PhotoGallery]: processPhotoAttachments({
        acceptedPseudoTypes: [PseudoPostType.PhotoGallery],
      }),
      [PseudoPostType.Video]: processVideoAttachments({
        acceptedPseudoTypes: [PseudoPostType.Reel],
      }),
      [PseudoPostType.Reel]: processReelAttachments({
        acceptedPseudoTypes: [PseudoPostType.Video],
      }),
    },
    [TYPE_INSTAGRAM]: {
      [PseudoPostType.PhotoGallery]: processPhotoAttachments({}),
      [PseudoPostType.Reel]: processStoryAttachments({}),
      [PseudoPostType.Story]: processReelAttachments({}),
    },
    [TYPE_LINKEDIN]: {
      [PseudoPostType.PhotoGallery]: processPhotoAttachments({
        acceptedPseudoTypes: [PseudoPostType.PhotoGallery],
      }),
    },
    [TYPE_TWITTER]: {
      [PseudoPostType.PhotoGallery]: processPhotoAttachments({
        acceptedPseudoTypes: [PseudoPostType.PhotoGallery],
      }),
    },
    [TYPE_GOOGLE_MY_BUSINESS]: {
      [PseudoPostType.Event]: processAllAttachments,
      [PseudoPostType.Status]: processAllAttachments,
      [PseudoPostType.Offer]: processAllAttachments,
    },
    [TYPE_THREADS]: {
      [PseudoPostType.PhotoGallery]: processPhotoAttachments({
        acceptedPseudoTypes: [PseudoPostType.PhotoGallery],
      }),
    },
  };

  const attachments = handlerByPageType?.[form.page.type]?.[pseudoPost.key]?.({
    pseudoPost,
    form,
    attachmentsByPseudoType,
    attachmentCards,
  });

  return attachments ?? attachmentCards;
};
